module.exports = __webpack_public_path__ + "img/pic04.8d4df27e.png";